<template>
	<div class="flexCol alit">
		<div class="" style="position: relative;width: 100%;">
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/%E5%A4%B4%E9%83%A8.png"
				style="width: 100%;" alt="" />
		<!-- 	<div class="" style="position: absolute;right: 100px;top: 160px;text-align: right;">
				<h1 class="">新闻资讯</h1>
				<div class="">为您提供千广科技的最新新闻咨询</div>
			</div> -->
		</div>
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">领导考察调研</div>
		<alienSwiper></alienSwiper>
		<div v-for="item in dataList" class="list flex" @click="goInfo(item)">
			<img :src="item.picUrl" alt="" />
			<div class="flexCol justb" style="width: 100%;">
				<div>
					<div class="title" style="text-align: left;">{{ item.title }}</div>
					<div class="content" v-html="item.introduction">
					</div>
				</div>
				<div class="flex justb">
					<!-- <div class="flex time">
						发布时间：44444 阅读：66666
					</div>
					<div class="flex fl">
						分类：<a style="font-size: 14px;">3333</a>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
		import alienSwiper from '../../components/certifySwiper/index5.vue'
	import {
		ref
	} from 'vue'
	import {
		useRouter
	} from 'vue-router';
	const router = useRouter();
	const dataList = [{
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/1.png',
		title: '国家农业农村部党组成员、副部长黄艳考察调研',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/3.png',
		title: '重庆市副市长郑向东到交易平台考察调研',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/6.png',
		title: '中央电视台采访干广科技董事长',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/5.png',
		title: '法国领事到访交易中心考察',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/7.png',
		title: '重庆电视台采访干广科技董事长',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/4.png',
		title: '海南省政协副主席肖莺子、重庆市政协副主席李静考察调研',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/8.png',
		title: '两江新区电视台采访干广科技',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/9.png',
		title: '重庆市商委主任、市农委主任、市场监管局长、市经信委主任、产业协会会长发布平台上线',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/10.png',
		title: '重庆市农业农村委智慧农业处长万俊新莅临考察',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/11.png',
		title: '张掖市甘州区委副书记、区长赵新福莅临考察',
		introduction: ''
	}, {
		picUrl: 'https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E6%96%B0%E9%97%BB%E5%8A%A8%E6%80%81/13.png',
		title: '甘肃天水市政府莅临干广科技考察调研',
		introduction: ''
	}]

	//新闻详情
	function goInfo(e) {
		router.push({
			path:'newsInfo',
			query:e
		})
	}
</script>

<style lang="scss" scoped>
	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}
	.list {
		border-bottom: 1px solid #ccc;
		padding: 0 10px 10px 10px;
		margin-top: 20px;
		cursor: pointer;
		width: 80%;

		img {
			width: 200px;
			height: 140px;
			margin-right: 10px;
			border-radius: 10px;
		}

		.fl {
			font-size: 14px;
			color: #333333;

			a {
				color: #2FC45C;
				margin-right: 5px;
			}
		}

		.time {
			font-size: 12px;
			color: #333333;
		}

		.content {
			width: 100%;
			color: #333;
			font-size: 14px;
			line-height: 22px;
			letter-spacing: 1px;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;

			p {
				font-size: 13px !important;
			}
		}

		.title {
			font-size: 18px;
			font-weight: 600;
			color: #000;
			margin-bottom: 10px;
			letter-spacing: 1px;
		}
	}
</style>